import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { PermisosService } from "src/app/services/permisos.service";

@Directive({
  selector: "[hasSomePermission]",
})
export class HasSomePermissionDirective {
  @Input() set hasSomePermission(permission: string[]) {
    this.viewContainer.clear();
    const temp = this.permisosServ.getPermisos();
    if (permission.some((s) => temp.includes(s))) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permisosServ: PermisosService
  ) {}
}
